
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import EntryFoodTunnel from './components/EntryFoodTunnel';
import SustainableLiving from './components/SustainableLiving';
import RenewableEnergy from './components/RenewableEnergy';
import TraditionalHeritage from './components/TraditionalHeritage';
import PickYourOwn from './components/PickYourOwn';
import BeAFarmer from './components/BeAFarmer';
import RoseGarden from './components/RoseGarden';
import TamilCulture from './components/TamilCulture';
import Permaculture from './components/Permaculture';
import SquareInchFarming from './components/SquareInchFarming';
import ModernFarming from './components/ModernFarming';
import ProtectedCultivation from './components/ProtectedCultivation';
import InteractWithFarmers from './components/InteractWithFarmers';
import BoutiqueStore from './components/BoutiqueStore';
import FishingExperience from './components/FishingExperience';
import NativeNatural from './components/NativeNatural';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';
import SocialFloat from './components/SocialFloat';

const Home = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Poppins, sans-serif' }}>
      <Navigation />
      <main>
        <section id="hero">
          <Hero />
        </section>
        <section id="entry-food-tunnel">
          <EntryFoodTunnel />
        </section>
        {/* <section id="sustainable-living">
          <SustainableLiving />
        </section> */}
        <section id="renewable-energy">
          <RenewableEnergy />
        </section>
        {/* <section id="heritage">
          <TraditionalHeritage />
        </section> */}
        <section id="pick-your-own">
          <PickYourOwn />
        </section>
        {/* <section id="be-a-farmer">
          <BeAFarmer />
        </section> */}
        <section id="rose-garden">
          <RoseGarden />
        </section>
        {/* <section id="tamil-culture">
          <TamilCulture />
        </section> */}
        <section id="permaculture">
          <Permaculture />
        </section>
        <section id="square-inch-farming">
          <SquareInchFarming />
        </section>
        <section id="modern-farming">
          <ModernFarming />
        </section>
        <section id="protected-cultivation">
          <ProtectedCultivation />
        </section>
        {/* <section id="interact-farmers">
          <InteractWithFarmers />
        </section> */}
        {/* <section id="boutique">
          <BoutiqueStore />
        </section> */}
        {/* <section id="fishing">
          <FishingExperience />
        </section> */}
        <section id="native-natural">
          <NativeNatural />
        </section>
        <Newsletter />
      </main>
      <Footer />
      <SocialFloat />
    </div>
  );
};

export default Home;
